__turbopack_context__.v({
  "root": "PointsExplainerSection-module__mT9UAa__root",
});
